const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AppointementList/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        today: 'Heute',
        yesterday: 'Gestern',
        tomorrow: 'Morgen',
        allDay: 'Ganztägig',
        from: 'Ab',
        until: 'bis',
        begin: 'Beginn',
        end: 'Ende',
        openEnd: 'Offen',
        confirmEintritt: 'Eintritt bestätigen',
        confirmed: 'Bestätigt',
        cancelAppointment: 'Termin stornieren',
        rescheduleAppointment: 'Termin umbuchen',
        appointment: 'Termin',
        entry: 'Eintritt Station',
        leave: 'Austritt Station',
        operation: 'Operation',
        emergency: 'Notfallanmeldung',
        fachperson: 'Fachperson:',
        appointmentCreatedByMe: 'Durch mich erstellt',
        appointmentDefaultTitle: 'Termin',
        planned: 'Geplant',
        provisionally: 'Provisorisch',
        standort: 'Standort:',
        duration: 'Dauer:',
    },
    __RELATIVE_SOURCE_FILE__
);
